import * as React from 'react'
import { sumBy, indexOf } from 'lodash'

interface Props {
  sectionPercent: Array<any>,
  sections: Array<any>
  checkPanel: Array<string>
}

let style = {
  "width": ""
}


function getCountRequired(sections: Array<any>, checkPanel: Array<string>) {
  let count = 0;
  for (let section of sections) {
    count += getCountRequiredInSection(section.controls, checkPanel);
  }

  return count;
}

function getCountRequiredInSection(controls: Array<any>, checkPanel: Array<string>)  {
  for (let ctrl of controls){
    if(ctrl.type.toUpperCase() !== 'PANEL' && ctrl.required){
      return 1;
    }else if(indexOf(checkPanel, ctrl.id) > -1) {
      return getCountRequiredInSection(ctrl.controls, checkPanel);
    }
  }

  return 0;
}

export function countProgress({ sectionPercent, sections, checkPanel }: Props) {
  const sum = sumBy(sectionPercent, (o: any) => o.percent);
  let percent = 0;

  if (sum > 0) {
    percent = parseInt((sum / (getCountRequired(sections, checkPanel) * 100) * 100).toString(), 0)
  }
  return percent;
}

export default function Progress({ sectionPercent, sections, checkPanel }: Props) {
  let sum = sumBy(sectionPercent, (o: any) => o.percent)
  let status = 'danger';

  if (sum > 0) {
    let percent = parseInt((sum / (getCountRequired(sections, checkPanel) * 100) * 100).toString(), 0)
    var new_width = `${percent}%`

    if (percent > 0 && percent <= 45) status = 'danger';
    else if (percent > 45 && percent < 100) status = 'warning';
    else if (percent >= 100) status = 'success';
    return (
        <div className="reportbox-progress">
          <div className="progress">
            <div className={`progress-bar progress-bar-${status}`} role="progressbar" style={{width:new_width}}>
              {`Заполнено на ${percent}%`}
            </div>
          </div>
        </div>
    )
  }
  return <div> </div>
}
